module.exports = __webpack_public_path__ + "static/media/travelcard.f376b882.svg";